// extracted by mini-css-extract-plugin
export default {"mainContainer":"login_mainContainer__MNxqn","formContainer":"login_formContainer__DRTmF","formInput":"login_formInput__nX6Ua","forgotPass":"login_forgotPass__bAX-9"};